// Moteur sonore de tension pour La Spirale — Web Audio, sans fichier externe.
// Battement de cœur qui s'accélère par manche, drone grave, tic-tac en fin de chrono.
export function createTensionAudio() {
  let ctx = null, drone = null, droneGain = null, master = null;
  let beatTimer = null, round = 1, muted = false, running = false;

  const ensure = () => {
    if (ctx) return;
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    ctx = new AC();
    master = ctx.createGain();
    master.gain.value = muted ? 0 : 0.35;
    master.connect(ctx.destination);
  };

  const thump = () => {
    if (!ctx || muted) return;
    const t = ctx.currentTime;
    const lub = (start, peak, f0, f1) => {
      const o = ctx.createOscillator(), g = ctx.createGain();
      o.type = "sine";
      o.frequency.setValueAtTime(f0, t + start);
      o.frequency.exponentialRampToValueAtTime(f1, t + start + 0.14);
      g.gain.setValueAtTime(0.0001, t + start);
      g.gain.exponentialRampToValueAtTime(peak, t + start + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, t + start + 0.3);
      o.connect(g); g.connect(master);
      o.start(t + start); o.stop(t + start + 0.34);
    };
    lub(0, 0.9, 72, 44);
    lub(0.17, 0.5, 62, 40);
  };

  const scheduleBeats = () => {
    clearTimeout(beatTimer);
    if (!running) return;
    thump();
    const interval = Math.max(470, 1250 - (round - 1) * 108); // r1 ~1250ms → r8 ~490ms
    beatTimer = setTimeout(scheduleBeats, interval);
  };

  return {
    start(r = 1) {
      ensure();
      if (!ctx) return;
      if (ctx.state === "suspended") ctx.resume().catch(() => {});
      round = r; running = true;
      if (!drone) {
        drone = ctx.createOscillator();
        droneGain = ctx.createGain();
        const lp = ctx.createBiquadFilter();
        drone.type = "sawtooth";
        drone.frequency.value = 55;
        lp.type = "lowpass"; lp.frequency.value = 170;
        droneGain.gain.value = 0.045;
        drone.connect(lp); lp.connect(droneGain); droneGain.connect(master);
        drone.start();
      }
      scheduleBeats();
    },
    setRound(r) {
      round = r;
      if (droneGain) droneGain.gain.value = 0.045 + (r - 1) * 0.007;
      if (running) scheduleBeats();
    },
    tick() {
      if (!ctx || muted) return;
      const t = ctx.currentTime;
      const o = ctx.createOscillator(), g = ctx.createGain();
      o.type = "square"; o.frequency.value = 900;
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(0.1, t + 0.005);
      g.gain.exponentialRampToValueAtTime(0.0001, t + 0.08);
      o.connect(g); g.connect(master);
      o.start(t); o.stop(t + 0.09);
    },
    sting(win) {
      if (!ctx || muted) return;
      const t = ctx.currentTime;
      const notes = win ? [523, 659, 784, 1047] : [330, 262, 220];
      notes.forEach((f, i) => {
        const o = ctx.createOscillator(), g = ctx.createGain();
        o.type = win ? "triangle" : "sawtooth";
        o.frequency.value = f;
        const st = t + i * 0.12;
        g.gain.setValueAtTime(0.0001, st);
        g.gain.exponentialRampToValueAtTime(0.22, st + 0.03);
        g.gain.exponentialRampToValueAtTime(0.0001, st + 0.5);
        o.connect(g); g.connect(master);
        o.start(st); o.stop(st + 0.55);
      });
    },
    setMuted(m) {
      muted = m;
      if (master && ctx) master.gain.value = m ? 0 : 0.35;
    },
    calm() {
      running = false;
      clearTimeout(beatTimer);
      try { if (drone) drone.stop(); } catch (e) { /* noop */ }
      drone = null; droneGain = null;
    },
    stop() {
      running = false;
      clearTimeout(beatTimer);
      try { if (drone) drone.stop(); } catch (e) { /* noop */ }
      drone = null; droneGain = null;
      if (ctx) { ctx.close().catch(() => {}); ctx = null; }
    },
  };
}
